import { useNavigate } from "react-router-dom";
import { GmailOAuthCallbackPage as GmailOAuthCallbackPageView } from "@/components/GmailOauthCallbackPage";

export function GmailOAuthCallbackPage() {
  const navigate = useNavigate();

  return (
    <GmailOAuthCallbackPageView
      onConnected={(id) =>
        navigate(`/settings/integrations/gmail/${id}/candidates`, { replace: true })
      }
      onBackToSettings={() => navigate("/settings/integrations/gmail", { replace: true })}
    />
  );
}
